import { ArticleEdgesOverlay } from 'app/modules/wallforming/components/scenes/objects/articles/ArticleEdgesOverlay';
import { ArticlePivotControls } from 'app/modules/wallforming/components/scenes/objects/articles/ArticlePivotControl';
import { ArticlesHandlerFactory } from 'app/modules/wallforming/components/scenes/objects/articles/ArticlesHandlerFactory';
import { BatchedMeshHandler } from 'app/modules/wallforming/components/scenes/objects/articles/BatchedMeshHandler';
import { NavigatorBatchedMeshHandler } from 'app/modules/wallforming/components/scenes/objects/articles/NavigatorBatchedMeshHandler';

interface ArticlesContainerProps {
    isMainCanvas: boolean;
}

export const Articles = ({ isMainCanvas }: ArticlesContainerProps) => {
    return (
        <>
            {isMainCanvas ? <BatchedMeshHandler /> : <NavigatorBatchedMeshHandler />}

            <ArticlesHandlerFactory isMainCanvas={isMainCanvas} />

            {isMainCanvas && (
                <>
                    <ArticleEdgesOverlay />
                    <ArticlePivotControls />
                </>
            )}
        </>
    );
};
